import { Quarter } from '../../TableData/TableData';

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export interface SortConfig {
  direction: SortDirection;
}

export interface TableHeaderProps {
  isScrolled: boolean;
  handleSort: () => void;
  sortConfig: SortConfig;
  allYearQuarters: Quarter[];
  selectedYear: number;
  yearRef: React.RefObject<HTMLTableCellElement | null>;
  selectedQuarter: number;
  hasDataForYear: (year: number) => boolean;
}
